const TOS = [
  ['Terms of Service', [
    'By using the pitvisor bot on your Discord server, you acknowledge that you have read and agreed to the following terms of service. It is your responsibility to inform the members of your Discord server about these terms. If you do not agree with any of the terms listed here, you are not allowed to use or invite pitvisor to your server.',
  ]],
  ['Disclaimer', [
    'Please note that the use of pitvisor for illegal purposes or in violation of Discord’s terms of service is strictly prohibited. We strive to provide the best user experience while also preventing any inappropriate or illegal use of the bot.',
    'If you come across anyone or any community using pitvisor in a way that goes against Discord’s terms of service or for illegal activities, please contact us at contact@ojee.net.',
  ]],
  ['Availability', [
    'pitvisor is provided free of charge and without any guarantee of availability. Analyses, recorded sessions and charts may be removed, delayed or fail at any time.',
  ]],
];

const PRIV = [
  ['Privacy Policy', [
    'The use of the pitvisor bot on Discord requires the collection of certain user data, including but not limited to Discord usernames and IDs. By using the bot, you agree to the terms of this privacy policy.',
  ]],
  ['What this website stores', [
    'The website itself sets no cookies and creates no account. Analysis requests are cached on the server keyed only by the options you chose (year, grand prix, session, drivers) so that the next person asking the same question does not wait a minute for it.',
  ]],
  ['Access to data', [
    'Access to data is restricted to the bot’s developers and is only used for the development, testing, and implementation of new features. The data is not sold, shared, or provided to any third parties, except where required by law or in accordance with a terms of service agreement.',
  ]],
  ['Storage of data', [
    'The data is secured to prevent external access, however no guarantee is provided and the bot owners assume no liability for the unintentional or malicious breach of data. In the event of unauthorised data access, users will be notified through the Discord client application.',
  ]],
  ['User rights', [
    'You have the right to request a view of the data associated with your Discord account and to request the removal of relevant data.',
  ]],
  ['Underage users', [
    'The bot is not intended for use by minors under the age of 13 or the age of legal consent in their country, and no information will be knowingly stored from an underage user.',
  ]],
  ['Questions', [
    'If you have any questions or concerns about the data being stored from your account, please contact .ojee on Discord.',
  ]],
];

export default function Legal({ kind }) {
  const sections = kind === 'priv' ? PRIV : TOS;
  const heading = kind === 'priv' ? 'Privacy policy' : 'Terms of service';

  return (
    <article className="pv-prose">
      <h1>{heading}</h1>
      {sections.slice(1).map(([title, paras]) => (
        <section key={title}>
          <h2>{title}</h2>
          {paras.map((p, i) => <p key={i}>{p}</p>)}
        </section>
      ))}
    </article>
  );
}
